import { JSONSchema7 } from "json-schema";

export const ExplainMoreMetadataSchema: JSONSchema7 = {
  description: "More features explanation.",
  type: "object",
  $schema: "http://json-schema.org/draft-07/schema#",
};
